import { PointsAccountingTokens } from '@/domain/DITokens'
import { TransactionNotFoundException } from '@/domain/points/accounting/exception/TransactionNotFoundException'
import { Transaction } from '@/domain/points/accounting/model/Transaction'
import type { IPointsAccountingRepository } from '@/domain/points/accounting/repository/contract/IPointsAccountingRepository'
import { inject, injectable } from 'inversify'

@injectable()
export class GetTransactionByIdUseCase {
  constructor(
    @inject(PointsAccountingTokens.repository.IPointsAccountingRepository)
    private readonly repository: IPointsAccountingRepository,
  ) {
  }

  public async execute(transactionId: string): Promise<Transaction> {
    const id = (transactionId ?? '').trim()

    if (!id) {
      throw new TransactionNotFoundException()
    }

    return await this.repository.getTransactionById(id)
  }
}

